<template>
    <v-app>
        <TheNavBar />
        <v-content>
            <router-view />
        </v-content>
        <Message />
        <TheFooter />
    </v-app>
</template>

<script>
import TheNavBar from '@/components/TheNavBar'
import TheFooter from '@/components/TheFooter'
import Message from '@/components/Message'

export default {
    name: 'App',
    components: {
        TheNavBar,
        TheFooter,
        Message
    }
}
</script>
